import { Component, OnDestroy } from '@angular/core';
import { CacheService, ParameterHandlerService } from 'projects/common/src/app/services';
import { BooleanStateService } from 'src/app/modules/core/services/boolean-state.service';
import { MachineContextService } from 'src/app/modules/core/services/parameter/machine-context/machine-context.service';
import { StateSidebarService } from 'src/app/modules/sidebar/services/state-sidebar.service';
import { ScreenViewService } from 'src/app/modules/widget/services/screen-view.service';
import { CommunicationService } from 'src/app/services/communication';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { DashboardWidgetChartComponent } from '../../dashboard-widget-chart/dashboard-widget-chart.component';
import { IDelayTimeTruckEmbedded } from 'src/app/modules/widget/interfaces/delay-time-truck-embedded';
import { IShift } from 'src/app/modules/core/interfaces';
import Highcharts from 'highcharts';
import { DatePresentationPipe } from 'src/app/modules/core/pipes/date-presentation.pipe';

@Component({
  selector: 'app-delay-time-truck-embedded',
  templateUrl: './delay-time-truck-embedded.component.html',
  styleUrls: ['./delay-time-truck-embedded.component.scss'],
})
export class DelayTimeTruckEmbeddedComponent extends DashboardWidgetChartComponent implements OnDestroy {
  public delayTimeDataList: IDelayTimeTruckEmbedded[];
  public inputDate: any;
  public selectedZone: any;
  public displayMessage = false;
  public hasData: boolean;
  public showLegend: boolean;
  public filterDelayOperative: any;

  constructor(
    protected progressBarService: BooleanStateService,
    protected communication: CommunicationService,
    protected parameterService: ParameterHandlerService,
    protected sidebarService: StateSidebarService,
    protected cacheService: CacheService,
    protected machineContext: MachineContextService,
    private languageService: LanguageService,
    private datePipe: DatePresentationPipe,
    protected screenViewService: ScreenViewService,
  ) {
    super(progressBarService, communication, parameterService, sidebarService, cacheService, machineContext, screenViewService);
    this.initRequestParams();
    this.showLegend = false;
  }

  /**
   * Init request params
   */
  private initRequestParams(): void {
    this.params = {
      hasShift: true,
      hasCompany: true,
      hasDate: true,
      hasMachineType: true,
      hasZone: true,
    };
  }

  /**
   * Draw chart status Park
   */
  public drawView(chartOptions?: any): any {
    const machineType = this.parameterService.parameters.item('machine-context').value || 'no disponible';
    const date = this.parameterService.parameters.item('date').value;
    const shift = this.parameterService.parameters.item('shift').value as IShift;
    const user = this.parameterService.parameters.item('user-data').value;

    this.hasData = !!chartOptions.length;
    if (chartOptions.length > 0) {
      this.delayTimeDataList = chartOptions;
      const buildedSeries = this.buildSeries(this.delayTimeDataList);

      const data = {
        chart: {
          marginTop: 100,
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          zoomType: 'xy',
        },
        title: {
          text: '',
        },
        subtitle: {
          text: `${this.languageService.message('company')}: ${user.company.name},
                ${this.languageService.message('device')}: ${this.languageService.message(machineType.name)},
                ${this.languageService.message('date')}: ${this.datePipe.transform(date)},
                ${this.languageService.message('shift_')}: ${shift.name}`,
        },
        credits: {
          enabled: false,
        },

        plotOptions: {
          pie: {
            shadow: false,
            cursor: 'pointer',
          },
          series: {
            states: {
              hover: {
                enabled: true,
                halo: {
                  size: 0,
                },
              },
            },
          },
        },
        tooltip: {
          backgroundColor: '#433e3e',
          borderColor: '#433e3e',
          borderRadius: 2,
          style: {
            color: 'white',
          },
          useHTML: true,
          formatter(): string {
            const color = this.point.options.color?.replace('0.5', '1');
            const hours = Number(Number(this.y) / 60 / 60).toFixed(2);

            return `<div style="width: 190px; white-space: nowrap; overflow: hidden;">
                          <strong style="font-weight: 700;"></strong> <br>
                          <span style="font-weight: 400; color: ${color}">${this.key}</span> <br>
                          <span style="font-weight: 400;">Demora: ${hours} Hrs | ${Number(this.percentage).toFixed(2)}%</span>
                    </div>
            `;
          },
        },
        series: buildedSeries,
      };

      this.chart = Highcharts.chart(this.chartTarget.nativeElement, data as any, (chart) => {
        if (!this.hasData) {
          const newX = chart.plotWidth / 3 + chart.plotLeft;
          const newY = chart.plotHeight / 2 + chart.plotTop;
          chart.renderer
            .text('La solicitud no arrojó resultados', newX, newY)
            .css({
              color: '#4572A7',
              fontSize: '24px',
            })
            .add();
        } else {
          this.showLegend = true;
        }
      });
      window.dispatchEvent(new Event('resize'));
    } else {
      this.displayMessage = false;
    }
  }

  /**
   *  Build series for the pie
   *
   * @param delayTimeDataList parameter value
   */
  private buildSeries(delayTimeDataList: IDelayTimeTruckEmbedded[]): any {
    return [
      {
        name: this.languageService.message('out_of_service'),
        type: 'pie',
        yAxis: 0,
        minPointSize: 10,
        innerSize: '20%',
        zMin: 0,
        data: delayTimeDataList.map((d) => ({
          name: d.stretchType,
          x: d.durationAtPercentage,
          y: d.durationAtSeconds,
          color: d.color,
          borderColor: d.color,
        })),
        borderWidth: 2,
        zIndex: 2,
      },
    ];
  }

  /**
   * On destroy component
   */
  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
